import { render, staticRenderFns } from "./MasterLanding.vue?vue&type=template&id=50651c9e&"
import script from "./MasterLanding.vue?vue&type=script&lang=js&"
export * from "./MasterLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports